import { render, staticRenderFns } from "./AngleSetting.vue?vue&type=template&id=4e3a3574&scoped=true"
import script from "./AngleSetting.vue?vue&type=script&lang=js"
export * from "./AngleSetting.vue?vue&type=script&lang=js"
import style0 from "./AngleSetting.vue?vue&type=style&index=0&id=4e3a3574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a3574",
  null
  
)

export default component.exports